export default class Price {
	calculationType: string;

	formula: string;

	constructor(calculationType: string, formula: string) {
		this.calculationType = calculationType;
		this.formula = formula;
	}
}
